import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SimpleFilterChoiceShape } from 'utils/shapes';

import ProjectList from 'components/projects/ProjectList';
import { loadItems } from 'ducks/projectlist';
import reverseUrl from 'utils/urls';

const mapDispatchToProps = (dispatch) => ({
    loadItems: () => dispatch(loadItems()),
});

@connect(null, mapDispatchToProps)
class ProjectListWrapper extends Component {
    static propTypes = {
        loadItems: PropTypes.func.isRequired,
        isAuthenticated: PropTypes.bool.isRequired,
    };

    componentDidMount = () => {
        // Set all filters in single action
        this.props.loadItems();
    };

    render() {
        return (
            <div>
                <div className="arena__header mb-5">
                    <div className="arena__header__title arena__header__right">
                        <h2 className="mb-3 nomargins">{gettext('Workshops and competitions')}</h2>
                        {!this.props.isAuthenticated ? (
                            <a className="button--signup btn" href={reverseUrl('trafo-register')}>
                                {gettext('Sign up on Trafo to join')}
                            </a>
                        ) : null}
                    </div>
                </div>
                <ProjectList />
            </div>
        );
    }
}

export default ProjectListWrapper;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectListWrapper.js